// extracted by mini-css-extract-plugin
export default {"card":"newsitem_card__Sr2Px","img_box":"newsitem_img_box__H-hdB"};